import { render, staticRenderFns } from "./dispatchList.vue?vue&type=template&id=f79c4b7e"
import script from "./dispatchList.vue?vue&type=script&lang=js"
export * from "./dispatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports